export default __webpack_public_path__ + "static/media/mediumRisk.a00fa8fa.svg";